import { Component, OnInit } from '@angular/core';
import { PublicService } from 'src/app/servicios/public/public.service';
import { ServiceService } from 'src/app/servicios/service.service';

@Component({
  selector: 'app-logros',
  templateUrl: './logros.component.html',
  styleUrls: ['./logros.component.css']
})
export class LogrosComponent implements OnInit {

  public logros : any[] = [];
  public serve: any;

  constructor(private servi: PublicService, private service: ServiceService) { 
    this.serve = this.service.server;
    this.servi.Logros()
      .subscribe(data => {
        for (const item of data['data']) {
          this.logros.push(item);
        }
      }); 
  }

  ngOnInit() {
  }

}
